import { MdOutlineMailOutline } from "react-icons/md";
import { LuPhone } from "react-icons/lu";

type Props = { data: any };

const ContactsSalon = ({ data }: Props) => {
  return (
    <div className="flex flex-wrap gap-4 justify-self-start w-full h-full">
      <div className="flex items-center gap-2">
        <MdOutlineMailOutline className="flex items-center text-color-primary bg-[#EEF0FF] w-[25px] h-[25px] p-1 rounded-lg" />
        <span className="text-color-primary text-sm font-normal">
          {data?.email}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <LuPhone className="flex items-center text-color-primary bg-[#EEF0FF] rounded-lg w-[25px] h-[25px] p-1 " />
        <span className="text-color-primary text-sm font-normal">
          {data?.contact_number}
        </span>
      </div>
    </div>
  );
};

export default ContactsSalon;
